import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import { listSeparator } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuSeparatorProps extends PartProps<BaseContextMenu.Separator.Props> {
  className?: string
}

function ContextMenuSeparator({ className, ...props }: ContextMenuSeparatorProps) {
  return <BaseContextMenu.Separator className={twMerge(listSeparator, className)} {...props} />
}

export { ContextMenuSeparator }
